/**
 * Space Manage → Members: the moderator directory of current, banned, and
 * former members, plus moderator notes. Gated by the `manageMembers` flag.
 *
 * Paging is keyset (opaque cursor), never offset, so a page costs the same at
 * member 100 000 as at member 1.
 *
 * @module api/space-member-directory
 */
/** Which population the directory lists. `active` is the default. */
export const SPACE_MEMBER_DIRECTORY_STATUSES = ['active', 'banned', 'former'];
/**
 * Sort keys. `recent` orders by the status's own timestamp: joined for
 * `active`, banned for `banned`, left for `former`. `name` orders by username.
 */
export const SPACE_MEMBER_DIRECTORY_SORTS = [
    'recent_desc',
    'recent_asc',
    'name_asc',
    'name_desc',
];
export const SPACE_MEMBER_DIRECTORY_DEFAULT_SORT = 'recent_desc';
export const SPACE_MEMBER_DIRECTORY_PAGE_DEFAULT = 50;
export const SPACE_MEMBER_DIRECTORY_PAGE_MAX = 100;
/** Filtered totals stop counting here; the UI shows "N+". */
export const SPACE_MEMBER_DIRECTORY_COUNT_CAP = 10_000;
/**
 * Search terms shorter than this match a whole username / nickname instead of
 * a prefix (a one-letter prefix would walk most of a large Space).
 */
export const SPACE_MEMBER_DIRECTORY_PREFIX_MIN_LENGTH = 2;
/** Search terms longer than this are rejected (usernames are far shorter). */
export const SPACE_MEMBER_DIRECTORY_QUERY_MAX_LENGTH = 64;
/** How a former member's membership ended. */
export const SPACE_MEMBER_DEPARTURE_REASONS = ['left', 'kicked', 'expired'];
export const SPACE_MEMBER_NOTE_MAX_LENGTH = 2000;
export const SPACE_MEMBER_NOTE_PAGE_DEFAULT = 20;
export const SPACE_MEMBER_NOTE_PAGE_MAX = 50;
/** Notes one Space may hold about one member. */
export const SPACE_MEMBER_NOTE_MAX_PER_MEMBER = 100;
export const SPACE_MEMBER_KICK_REASON_MAX_LENGTH = 500;
/** Strip `@`, trim, lowercase. Returns '' when nothing searchable is left. */
export function normalizeSpaceMemberDirectoryQuery(raw) {
    if (!raw)
        return '';
    return raw.trim().replace(/^@+/, '').trim().toLowerCase();
}
//# sourceMappingURL=space-member-directory.js.map